import { createStore, applyMiddleware, compose } from 'redux';
import { routerMiddleware } from 'react-router-redux';
import thunkMiddleware from 'redux-thunk';
import createLogger from 'redux-logger';

import history from './browser-history';
import localStorageAPI from './services/local-storage-api';
import AppReducer from './reducers';
import listenLogoutActionMiddleware from './middlewares/listen-logout-action-middleware';
import listenLoginActionMiddleware from './middlewares/listen-login-action-middleware';

let spreeStoreVariable;
const dataFromLocalStorage = localStorageAPI.load();

const middlewares = [
    thunkMiddleware,
    listenLogoutActionMiddleware,
    listenLoginActionMiddleware,
    routerMiddleware(history),
];
//
// if (process.env.NODE_ENV === 'development') {
//     const logger = createLogger();
//
//     middlewares.push(logger);
// }

const middlewareEnhancer = applyMiddleware(...middlewares);

const enhancers = [middlewareEnhancer];
const composedEnhancers = compose(...enhancers);

if (dataFromLocalStorage) {
    const preloadedState = {
        order: dataFromLocalStorage.order,
        user: dataFromLocalStorage.user,
        auth: dataFromLocalStorage.auth,
        placedOrder: dataFromLocalStorage.placedOrder,
        locale: dataFromLocalStorage.locale,
        stores: AppReducer.stores,
        zones: dataFromLocalStorage.zones,
        municipalities: dataFromLocalStorage.municipalities,
        wallets: dataFromLocalStorage.wallets,
        anonymousUser: dataFromLocalStorage.anonymousUser,
    };

    if (preloadedState && preloadedState.order && preloadedState.order.addingProductToCart) {
        preloadedState.order.addingProductToCart = false;
    }

    spreeStoreVariable = createStore(AppReducer, preloadedState, composedEnhancers);
} else {
    spreeStoreVariable = createStore(AppReducer, {}, composedEnhancers);
}

const spreeStore = spreeStoreVariable;

export default spreeStore;



/** WEBPACK FOOTER **
 ** ./src/store.js
 **/